import React, { useContext } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Link as MuiLink,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { AppContext } from "../utils";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../assets/logo.png";
const pages = [
  {
    name: "About",
    to: "https://solardex.finance/#about",
    target: "_blank",
  },
  {
    name: "Tokenomics",
    to: "https://solardex.finance/#tokenomics",
    target: "_blank",
  },
  {
    name: "Roadmap",
    to: "https://solardex.finance/#roadmap",
    target: "_blank",
  },
  {
    name: "Team",
    to: "https://solardex.finance/#team",
    target: "_blank",
  },
  {
    name: "Solar Token",
    to: "https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g#holders",
    target: "_blank",
  },
];

const StyledHashLink = styled(HashLink)({
  color: "white",
  textDecoration: "none",
});

const NavBar = () => {
  const { account, connect, disconnect } = useContext(AppContext);

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = React.useCallback((event) => {
    setAnchorElNav(event.currentTarget);
  }, []);

  const handleCloseNavMenu = React.useCallback(() => {
    setAnchorElNav(null);
  }, []);

  return (
    <AppBar position="static" color="transparent">
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ height: "6em" }}>
          <RouterLink to="/" style={{ textDecoration: "none" }}>
            <Box
              component="img"
              src={logo}
              alt="Solar Logo"
              sx={{ mr: 2, display: "flex" }}
            />
          </RouterLink>
          <Box
            sx={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "flex-end",
            }}
          >
            <Box
              display={{ xs: "none", md: "flex" }}
              gap={3}
              alignItems="center"
              fontFamily="Poppins"
              fontWeight={500}
              fontSize="13px"
              letterSpacing="1px"
            >
              {pages.map(({ name, to, target }) =>
                target ? (
                  <MuiLink
                    key={to + name}
                    href={to}
                    target={target}
                    rel="noreferrer"
                    sx={{
                      textDecoration: "none",
                      color: "#fff",
                      // width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {name}
                  </MuiLink>
                ) : (
                  <StyledHashLink key={to + name} to={to}>
                    {name}
                  </StyledHashLink>
                )
              )}
              <Button
                onClick={() => (account ? disconnect() : connect())}
                sx={{
                  color: "white",
                  "&, &:hover": {
                    background:
                      "radial-gradient(267.56% 2139.85% at 3.42% 30.43%, #AD00FF 0%, #26D2D1 100%) !important",
                  },
                }}
              >
                {account
                  ? account.slice(0, 4) + "..." + account.slice(-4)
                  : "Connect"}
              </Button>
            </Box>
            <Box display={{ xs: "flex", md: "none" }}>
              <IconButton
                size="large"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon sx={{ color: "white" }} />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                  "& .MuiPaper-root": {
                    backgroundColor: "#02052C",
                  },
                }}
              >
                {pages.map(({ name, to, target }) => (
                  <MenuItem key={to + name} onClick={handleCloseNavMenu}>
                    {target ? (
                      <MuiLink
                        href={to}
                        target={target}
                        rel="noreferrer"
                        color="inherit"
                        sx={{ textDecoration: "none" }}
                      >
                        {name}
                      </MuiLink>
                    ) : (
                      <StyledHashLink key={to + name} to={to}>
                        {name}
                      </StyledHashLink>
                    )}
                  </MenuItem>
                ))}
                <MenuItem onClick={handleCloseNavMenu}>
                  <Button
                    sx={{
                      color: "white",

                      "&, &:hover": {
                        background:
                          "radial-gradient(267.56% 2139.85% at 3.42% 30.43%, #AD00FF 0%, #26D2D1 100%) !important",
                      },
                    }}
                    onClick={() => (account ? disconnect() : connect())}
                  >
                    {account
                      ? account.slice(0, 4) + "..." + account.slice(-4)
                      : "Connect"}
                  </Button>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
